export function isGermanLocale(locale?: string | null): boolean {
    if (!locale) {
        return false
    }

    const sanitizedLocale = locale.toLowerCase().replace(/_/g, '-')
    const [language] = sanitizedLocale.split('-')

    return language === 'de'
}
